import app_color_palette from './style';

const data_ticket_state = {
  1: {
    en: 'To do',
    fr: 'À traiter',
    color: app_color_palette[0],
    value: 1,
  },
  2: {
    en: 'Waiting for customer',
    fr: 'Attente retour client',
    color: app_color_palette[1],
    value: 2,
  },
  3: {
    en: 'Waiting for supplier',
    fr: 'Attente retour fournisseur',
    color: app_color_palette[2],
    value: 3,
  },
  4: {
    en: 'Waiting for product return',
    fr: 'Attente retour matériel',
    color: app_color_palette[3],
    value: 4,
  },
  5: {
    en: 'Waiting for intervention',
    fr: 'Attente intervention',
    color: app_color_palette[4],
    value: 5,
  },
  6: {
    en: 'Stand-by',
    fr: 'Stand-by',
    color: app_color_palette[5],
    value: 6,
  },
  7: {
    en: 'intervention to be planned',
    fr: 'Intervention à prévoir',
    color: app_color_palette[6],
    value: 7,
  },
  8: {
    en: 'Ongoing',
    fr: 'En cours de traitement',
    color: app_color_palette[7],
    value: 8,
  },
  9: {
    en: 'Waiting for supplier intervention',
    fr: 'Attente intervention fournisseur',
    color: app_color_palette[4],
    value: 9,
  },
};

export default data_ticket_state;
